export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/curvedLine.a3a97fa8.svg","height":28,"width":136,"blurWidth":0,"blurHeight":0};